import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from '../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class DocumentSignDataService {
    public static _API_ENDPOINT = environment.apiEndPoint + 'DocumentSign/';

    constructor(private http: HttpClient, private router: Router) { }

    GetDocumentForSignature(type: string, signingToken: string) {
        return this.http.post(DocumentSignDataService._API_ENDPOINT + 'GetDocumentForSignature?type=' + type + "&signingToken=" + signingToken, null)
    }

    RecordResidentSignature(type: string, signatureId: string) {
        return this.http.post(DocumentSignDataService._API_ENDPOINT + 'RecordResidentSignature?type=' + type + "&signatureId=" + signatureId, null)
    }
}
